import { httpClient } from '@/modules/common/services/http/http-client';

const bffTradingBaseURL = `${process.env.VUE_APP_BFF_URL}/trading/v1`;
export const httpClientBffTrading = httpClient.withOptions({
  baseURL: bffTradingBaseURL
});

export interface CopytradeTokenParams {
  portfolioTypeId?: number;
}

export function postCopytradeToken(
  params?: CopytradeTokenParams
): Promise<{ token: string }> {
  return httpClientBffTrading.post('/copy-trade/generate-token', undefined, {
    params
  });
}
